//import { Locale } from '@ahsxp/base-translate';

import { Locale } from '@nx-ahs/base-translate';

export const locale: Locale = {
	lang: 'es',
	data: {
		TEST: 'SP: secure-messaging works!!!!!!!!!!!!!!!!!!!!!!!!',
		ACCOUNT_INFORMATION: 'SP: Account Information',
		ADD_MEMBER: 'SP: Add Member',
		AT: ' - ',
		CANCEL: 'Cancelar',
		CANNOT_REPLY: 'Este mensaje está marcado como cerrado y no se puede responder.',
		CLEAR: 'SP: Clear',
		CLOSE: 'SP: Close',
		CLOSED: 'Cerrado',
		CLOSE_TASK_MESSAGE_WARNING: '¿Está seguro de que desea marcar este mensaje como cerrado?',
		CONTACT_CENTER: 'Mesa de ayuda',
		CONTACT_PREFERENCE: 'Prefiero ser contactado por:',
		CONTACT_PREFERENCE_ERROR: 'Por favor seleccione un preferencia de contacto',
		CONVERSATION: 'SP: Conversation',
		DATE: 'Fecha',
		DESCRIPTION:
			'¿Necesita ayuda? Envíenos un mensaje y le responderemos en un plazo de 8 horas hábiles. Para hablar con nosotros, llame al 1-888-540-KIDS (5437) de lunes a viernes de 7:30 AM a 7:30 PM, hora del este.',
		FILTER_ON_MESSAGE_STATUS: 'SP: Filter on message status:',
		LAST_MESSAGE_RECIEVED: 'SP: Last Message Received On',
		MARK_OPEN: 'Marcar como Abierto',
		MARK_CLOSED: '¿Marcar Cerrado?',
		MARKED_CLOSED_BY: 'Marcado Cerrado por ',
		MESSAGE: 'SP: Message',
		MESSAGE_ERROR: 'Escriba un mensaje',
		MESSAGE_STATUS: 'SP: Message Status',
		NEW_SECURE_MESSAGE: 'Mensaje Nuevo',
		OPEN: 'Abierto',
		CONVERSATION_PHONE: 'Número de Teléfono',
		PHONENUMBER_ERROR: 'Por favor, ingrese un número de teléfono',
		PHONENUMBER_LABEL: 'Por favor, ingrese un número de teléfono',
		PAYMENT_PORTAL: 'SP: Premium Portal',
		PREFERRED_CONTACT_TIME: 'Hora preferida del día',
		RECURRING_PAYMENTS: 'SP: Recurring Payments',
		PREMIUM_AMOUNT: 'SP: Premium Amount',
		REGARDING: 'Eso se aplica al siguiente miembro:',
		REGARDING_ERROR: 'Por favor elige un beneficiario',
		SEARCH_MESSAGES: 'Buscar Mensajes',
		SELECT_ANY: 'SP: Select Any',
		SELECT_A_MEMBER: 'Selecciona un miembro',
		SEND: 'Enviar',
		STATUS: 'Estado',
		SUBJECT: 'Tengo una pregunta o preocupación sobre:',
		SUBJECT_ERROR: 'Por favor seleccione un tema',
		TITLE: 'Mensajería',
		TO_START_NEW_MESSAGE: 'SP: To start a new message click',
		TYPE_MESSAGE_HERE: 'Escriba su mensaje aquí',
		VIEW_MESSAGE: 'Ver mensaje',
		VIEW_MESSAGES: 'Mensajes',
		SecureMessage: 'Mensaje Seguro',
		Call: 'Llamada Telefónica',
		Other: 'Otro',
		EligibilityCoverage: 'Elegibilidad / Cobertura',
		EnrollmentPlanChange: 'Inscripción / Cambio de Plan',
		IDCards: 'Tarjetas de Identificación',
		Medicare: 'Medicare',
		Payment: 'Pago',
		PersonalInformation: 'Informacion personal',
		Services: 'Servicios',
		YES: 'SI',
		NO: 'NO',
		REOPEN: 'Reabrir',
		STATUS_CHANGED_TO: 'Estatus cambió a '
	}
};
